import { DeviceTableRow } from "./DeviceTableRow";
import { useTranslation } from 'react-i18next'



const DeviceTable = ({showData, filteredDevices, removeDevice, openEditDevice, deviceLocationLookup}) => {
    const { t } = useTranslation("settings");
    const getLocationInfo=(place_id) =>{
        const locationInfo = deviceLocationLookup?.get(place_id);
        if (!locationInfo) return "-";
      
        const { building="-", floor="-", placeName="-" } = locationInfo;
        const info = `${building} / ${floor} / ${placeName}`;
      
        const formattedInfo = info.replace(/\w\S*/g, function(word) {
          return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        });
        
        return formattedInfo
      }

      
    return ( 
        
    <div className="w-full">
        <table className="table-fixed">
            <thead className="">
            <tr className='border-b'>
              <th className="text-vekin font-semibold inline-flex gap-2 text-[16px]">{t('device_management.date')}</th>
              <th className="text-secondary text-[16px]">{t('device_management.type')}</th>
              <th className="text-secondary text-[16px]">{t('device_management.name')}</th>
              <th className="text-secondary text-[16px]">{t('device_management.location')}</th>
              <th className="text-secondary text-[16px]">{t('device_management.status.title')}</th>
              {showData && (
              <th className="text-right pr-10 text-secondary text-[16px] ">{t('device_management.action')}</th>
              )}
            </tr>
            </thead>
            <tbody className="">
    
              {filteredDevices?.map(device => (
                <DeviceTableRow
                  key={device?.id}
                  device={device}
                  showData={showData}
                  getLocationInfo={getLocationInfo}
                  openEditDevice={openEditDevice}
                  removeDevice={removeDevice}
                />
                ))}
            </tbody>
        </table>
    </div>

     );
}
 
export default DeviceTable;